function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  id: "Message-open",
  className: "cls-1",
  d: "M0,6.174V12.1a1.3,1.3,0,0,0,1.3,1.3H12.7A1.3,1.3,0,0,0,14,12.1V6.174a1.3,1.3,0,0,0-.519-1.038L7.78.859a1.3,1.3,0,0,0-1.558,0L.519,5.136A1.3,1.3,0,0,0,0,6.174ZM7,8.588,2.917,5.525,6.222,3.047a1.3,1.3,0,0,1,1.558,0l3.3,2.478Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "BeBold",
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/list.82b52c2e.svg";
export { SvgComponent as ReactComponent };